var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38073 2.39752L11.8557 0.901683C11.9148 0.893203 11.9751 0.89753 12.0324 0.914371C12.0897 0.931212 12.1427 0.960174 12.1878 0.999294C12.233 1.03841 12.2691 1.08678 12.2939 1.14111C12.3187 1.19544 12.3316 1.25446 12.3316 1.31418V18.6859C12.3316 18.7455 12.3187 18.8044 12.294 18.8587C12.2692 18.913 12.2331 18.9613 12.1881 19.0004C12.1431 19.0395 12.0902 19.0685 12.033 19.0854C11.9758 19.1023 11.9156 19.1067 11.8566 19.0983L1.3799 17.6025C1.18124 17.5742 0.999473 17.4752 0.86797 17.3236C0.736467 17.1721 0.664064 16.9782 0.664062 16.7775V3.22252C0.664064 3.02186 0.736467 2.82794 0.86797 2.67639C0.999473 2.52483 1.18208 2.42581 1.38073 2.39752ZM2.33156 3.94585V16.0542L10.6649 17.245V2.75502L2.33156 3.94585ZM13.1649 15.8334H15.6649V4.16668H13.1649V2.50002H16.4982C16.7192 2.50002 16.9312 2.58781 17.0875 2.74409C17.2438 2.90037 17.3316 3.11234 17.3316 3.33335V16.6667C17.3316 16.8877 17.2438 17.0997 17.0875 17.2559C16.9312 17.4122 16.7192 17.5 16.4982 17.5H13.1649V15.8334ZM7.49823 10L9.83156 13.3334H7.83156L6.49823 11.4283L5.1649 13.3334H3.1649L5.49823 10L3.1649 6.66668H5.1649L6.49823 8.57168L7.83156 6.66668H9.83156L7.49823 10Z",
    fill: "#2246DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLogo);
export default __webpack_public_path__ + "static/media/file_logo.bbd6d7edcfd42f5176adf02d3bf72537.svg";
export { ForwardRef as ReactComponent };